import React from "react";
import LoginPage from "app/Login/LoginPage";
import Loader from "components/Loading/Loader/Loader";


const MaintenanceModePage = React.lazy(() => import("components/MaintenanceModePage/MaintenanceModePage"))

const Login = ({message}) => {

    return (
        <>
        {
            !message ? (
                <React.Suspense fallback={<Loader/>}>
                    <MaintenanceModePage/>
                </React.Suspense>
            ) : (<LoginPage message={message}/>)
        }
        </>
    );
};
 
export default Login;